import { useEffect } from 'react';


export const useKeyboardShortcuts = (navigate) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            const { metaKey, shiftKey, key } = event;

            if (metaKey && shiftKey && key === '1') {
                navigate('/falcon-dashboard');
            } else if (metaKey && shiftKey && key === '2') {
                navigate('/thunes/fulfillments');
            } else if (metaKey && key === 'e') {
                navigate('/beneficiary-verification-dashboard');
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [navigate]);
};
